<es-header class="app-header" href="#" logo="examsoft" [name]="institutionName$ | async">
  <es-header-menu>
    <a *ngIf="canSwitchProfile$ | async" href="#" (click)="openSwitchProfileModal($event)" translate
      >Switch Profile</a
    >

    <a [routerLink]="['profile']" translate>My Profile</a>

    <a href="https://help.examsoft.com" target="_blank" rel="noopener" translate>
      Help Center
    </a>

    <a href="#" (click)="logout($event)" translate>Logout</a>
  </es-header-menu>
</es-header>

<app-switch-profile-modal
  *ngIf="isSwitchProfileModalOpen"
  (close)="closeSwitchProfileModal()"
  (switchProfile)="switchProfile()"
  [canSwitchProfile]="canSwitchProfile$ | async"
></app-switch-profile-modal>
